import React from "react";

function NosotrosCierre() {
  return (
    <section id="nosotros-cierre">
      <article>
        <h2 id="nosotros-cierre-title">
          Hicomerce. Tu socio en expansión digital.
        </h2>
      </article>
    </section>
  );
}

export default NosotrosCierre;